import _ from 'lodash';
import React, { Component } from 'react';
import { db } from '../../firebase';
import 'whatwg-fetch';
import validator from 'email-validator'

import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'

import signups from "../../data/signup.json";
const signups_labels = {"age": "年代", "sex": "性別", "family": "家族構成", "cleaning_frequency": "掃除頻度", "children": "子供", "pet": "ペット"}
const lots = ["30分コース", "60分コース"]

var MY_SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';
var slack = require('slack-notify')(MY_SLACK_WEBHOOK_URL);
slack.onError = function (err) {
  console.log('API error:', err);
};

// ユーザー特定のための乱数生成
const l = 16;
const c = "abcdefghijklmnopqrstuvwxyz0123456789";
const cl = c.length;
let r = "";
for(let i=0; i<l; i++) {
  r += c[Math.floor(Math.random()*cl)];
}
const uuid = r

export default class Web extends Component {
  constructor (props) {
    super(props);

    this.state = {
      family_name: "",
      first_name: "",
      family_name_kana: "",
      first_name_kana: "",
      zipcode: "",
      address: "",
      apartment: "",
      tel: "",
      email: "",
      age: "2",
      sex: "1",
      family: "0",
      cleaning_frequency: "0",
      children: "0",
      pet: "0",
      lot: "0",
      menu: "",
      schedule: "",
      terms: 0,
      privacy: 0,
      on_submit: false,
      errors: {}
    };
  }

  componentDidMount () {
    if ("30min.page" === document.domain) {
      ReactGA.initialize('UA-184751599-1', {gaOptions: {userId: uuid}});
      ReactGA.pageview(window.location.pathname + window.location.search);
      TagManager.initialize({gtmId: 'GTM-WQCC8C9'})
    }
  }

  setCheck (name, check) {
    var v = 0
    if (check === true) {
      v = 1
    }
    this.setState({[name]: v})
  }

  validation (e) {
    //console.log(this.state)
    var errors = {}

    // ユーザー名　入力　50文字以内
    if (this.state.family_name === "" || this.state.first_name === "") {
      errors["name"] = "氏名を入力してください"
    } else if (this.state.family_name.length > 50 || this.state.first_name.length > 50) {
      errors["name"] = "氏名は50文字以内で入力してください。";
    }
    if (this.state.family_name_kana === "" || this.state.first_name_kana === "") {
      errors["name_kana"] = "フリガナを入力してください"
    } else if (this.state.family_name_kana.length > 50 || this.state.first_name_kana.length > 50) {
      errors["name_kana"] = "フリガナは50文字以内で入力してください。";
    }

    // 郵便番号　入力　郵便番号チェック
    if (this.state.zipcode === "") {
      errors["zipcode"] = "郵便番号を入力してください。";
    } else if (!this.state.zipcode.match(/^[0-9,-]+$/)) {
      errors["zipcode"] = "郵便番号を正しく入力してください。";
    }

    // 住所　入力　50文字チェック
    if (this.state.address === "") {
      errors["address"] = "住所を入力してください。";
    } else if (this.state.address.length > 50) {
      errors["address"] = "住所は50文字以内で入力してください。";
    }

    // マンション名・部屋番号　入力　100文字チェック
    if (this.state.apartment === "") {
      errors["apartment"] = "マンション名・部屋番号を入力してください。";
    } else if (this.state.apartment.length > 100) {
      errors["apartment"] = "マンション名・部屋番号は100文字以内で入力してください。";
    }

    // 電話番号　入力　電話番号チェック（簡易版: 数字ハイフン,8~16文字）
    if (this.state.tel === "") {
      errors["tel"] = "電話番号を入力してください。";
    } else if (!this.state.tel.match(/^[0-9,-]+$/)) {
      errors["tel"] = "電話番号を正しく入力してください（半角数字もしくはハイフン以外の入力はできません）。";
    } else if (8 > this.state.tel.length || 16 < this.state.tel.length) {
      errors["tel"] = "電話番号を正しく入力してください。";
    }

    // メールアドレス　入力　メールアドレスチェック
    if (this.state.email === "") {
      errors["email"] = "メールアドレスを入力してください。";
    } else if(!validator.validate(this.state.email)) {
      errors["email"] = "メールアドレスを正しく入力してください。";
    }

    // 年代、性別、家族構成、掃除頻度、子供、ペット
    for (let x in signups_labels) {
      var error = 1
      for(let i = 0; i < signups[x].length; i++) {
        if (parseInt(this.state[x], 10) === i) {
          error = 0
        }
      }
      if (error) {
        errors[x] = signups_labels[x] + "を選択してください。";
      }
    }

    // 希望の時間数
    error = 1
    for(let i = 0; i < lots.length; i++) {
      if (parseInt(this.state.lot, 10) === i) {
        error = 0
      }
    }
    if (error) {
      errors["lot"] = "ご希望の時間数を選択してください。";
    }

    // 希望の掃除内容　入力　10000文字チェック
    if (this.state.menu === "") {
      errors["menu"] = "ご希望の掃除内容を入力してください。";
    } else if (this.state.menu.length > 10000) {
      errors["menu"] = "ご希望の掃除内容は10000文字以内で入力してください。";
    }

    // 希望の曜日・時間　入力　10000文字チェック
    if (this.state.schedule === "") {
      errors["schedule"] = "ご希望の曜日・時間を入力してください。";
    } else if (this.state.schedule.length > 10000) {
      errors["schedule"] = "ご希望の曜日・時間は10000文字以内で入力してください。";
    }

    // 利用規約への同意
    if (this.state.terms !== 1) {
      errors["terms"] = "利用規約への同意が必要です。";
    }

    // プライバシーポリシーへの同意
    if (this.state.privacy !== 1) {
      errors["privacy"] = "プライバシーポリシーへの同意が必要です。";
    }

    this.setState({errors: errors}, () => {
      if (Object.keys(this.state.errors).length === 0) {
        this.send()
      }
    });
  }

  send(e) {
    if (this.state.on_submit === false) {
      this.setState({on_submit: true});

      const data = _.cloneDeep(this.state);
      data.createdAt = Date.now();

      const event_info = {
        uuid: uuid,
        createdAt: data.createdAt
      }

      db.ref(`log/event/lp/`).push(event_info).then(function() {
        // Success
      }).catch(function (error) {
        // An error happened.
      });

      var scope = this

      const user_info = {
        family_name: data.family_name,
        first_name: data.first_name,
        family_name_kana: data.family_name_kana,
        first_name_kana: data.first_name_kana,
        zipcode: data.zipcode,
        address: data.address,
        apartment: data.apartment,
        tel: data.tel,
        email: data.email,
        age: parseInt(data.age, 10),
        sex: parseInt(data.sex, 10),
        family: parseInt(data.family, 10),
        cleaning_frequency: parseInt(data.cleaning_frequency, 10),
        children: parseInt(data.children, 10),
        pet: parseInt(data.pet, 10),
        lot: parseInt(data.lot, 10),
        menu: data.menu,
        schedule: data.schedule,
        uuid: uuid,
        createdAt: data.createdAt
      }

      db.ref(`lp/users/`).push(user_info).then(function() {
        // Update successful.
        scope.setState({on_submit: false});
        slack.success('キャンペーンの申し込みがありました！\n氏名：' + data.family_name + ' ' + data.first_name + '（' + data.family_name_kana + ' ' + data.first_name_kana + '）');
      }).then(function() {
        scope.props.history.push("/campaign_done");
      }).catch(function (error) {
        // An error happened.
        scope.setState({on_submit: false});
        scope.setState({errors: {"server": "サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください"}})
      });
    }
  }

  render () {
    const age_list = signups.age.map((v, i) => {
      let selected = ""
      if(parseInt(this.state.age, 10) === i){
        selected = "selected"
      }
      return <option value={i} selected={selected}>{v}</option>;
    });
    const sex_list = signups.sex.map((v, i) => {
      let selected = ""
      if(parseInt(this.state.sex, 10) === i){
        selected = "selected"
      }
      return <option value={i} selected={selected}>{v}</option>;
    });
    const family_list = signups.family.map((v, i) => {
      let selected = ""
      if(parseInt(this.state.family, 10) === i){
        selected = "selected"
      }
      return <option value={i} selected={selected}>{v}</option>;
    });
    const cleaning_frequency_list = signups.cleaning_frequency.map((v, i) => {
      let selected = ""
      if(parseInt(this.state.cleaning_frequency, 10) === i){
        selected = "selected"
      }
      return <option value={i} selected={selected}>{v}</option>;
    });
    const children_list = signups.children.map((v, i) => {
      let selected = ""
      if(parseInt(this.state.children, 10) === i){
        selected = "selected"
      }
      return <option value={i} selected={selected}>{v}</option>;
    });
    const pet_list = signups.pet.map((v, i) => {
      let selected = ""
      if(parseInt(this.state.pet, 10) === i){
        selected = "selected"
      }
      return <option value={i} selected={selected}>{v}</option>;
    });
    const lot_list = lots.map((v, i) => {
      let selected = ""
      if(parseInt(this.state.lot, 10) === i){
        selected = "selected"
      }
      return <option value={i} selected={selected}>{v}</option>;
    });
    return (
    <div className="sp home">
      <div className="content-wrapper">
        <div className="contents lp">

          <div className="notifications">
            <p className="notification-text">12月12日(土)から12月13日(日)午後1時頃までシステム障害が発生しておりました。深くお詫び申し上げます。現在は復旧しております。</p>
          </div>

          <div className="kv">
            <img src="/images/lp/kv.png" alt="30min." />
          </div>

          <div className="content">
            <img src="/images/lp/comment.png" alt="30min.がおすすめです！" />
            <div className="points">
              <dl className="point">
                <dt><img src="/images/lp/point1.png" alt="Point 1" /></dt><dd className="image"><img src="/images/lp/mansion.png" alt="" /></dd><dd className="title">マンション巡回型<br />サービス</dd><dd className="text">マンション内に同じサービス利用者がいるため、わざわざ来てもらうのも…という気持ちの負担なく、気軽にご依頼いただけます。</dd>
                <br className="clear" />
              </dl>
              <dl className="point">
                <dt><img src="/images/lp/point2.png" alt="Point 2" /></dt><dd className="image"><img src="/images/lp/timer.png" alt="" /></dd><dd className="title">ご利用は<br />週1回・30分から</dd><dd className="text">週1回、決まった曜日にスタッフがお伺いします。忙しいあなたの拘束時間は最小限に。</dd>
                <br className="clear" />
              </dl>
              <dl className="point">
                <dt><img src="/images/lp/point3.png" alt="Point 3" /></dt><dd className="image"><img src="/images/lp/staff.png" alt="" /></dd><dd className="title">ピンポイントで</dd><dd className="text">ピンポイントにあなたの気になるところを。おうちの綺麗をキープします。</dd>
                <br className="clear" />
              </dl>
            </div>
          </div>

          <div className="content">
            <img src="/images/lp/subtitle.png" alt="30min.のお掃除、体験してみませんか？お得な2回セットをご用意しました！" />
            <br /><br />
            <img src="/images/lp/course.png" alt="30分コース：30分×2回で3000円　60分コース：60分2回で5000円" />
            <br />
            <div className="caution">●お伺いは、週1回(平日)、同じ曜日の同じ時間帯になります。<br />●サービスのご提供可能時間：月〜土 10:00〜17:00<br />●同じコースの中であれば、お掃除場所は毎回自由に選べます。例えば、「60分コース」では「1回目キッチン、2回目お風呂」など、お選びいただいた箇所をお掃除いたします。<br />●料金は交通費込み、税抜き価格です。</div>
            <div className="limited"><img src="/images/lp/limited3.png" alt="お申し込みは先着30名様まで" /></div>
            <br className="clear" />
            <div className="recommend">ご利用の仕方はライフスタイルに合わせて</div>
            <img src="/images/lp/recommend.png" alt="" />
            <br /><br />
            <div className="step-title">ご利用までの流れ</div>
            <div className="steps">
              <dl className="step">
                <dt><img src="/images/lp/step1.png" alt="Step 1" /></dt><dd className="image"><img src="/images/lp/form.png" alt="" /></dd><dd className="text">下記のフォームよりお申し込みください。</dd>
                <br className="clear" />
              </dl>
              <dl className="step">
                <dt><img src="/images/lp/step2.png" alt="Step 2" /></dt><dd className="image"><img src="/images/lp/tel.png" alt="" /></dd><dd className="text">事務局よりお電話またはメールさせていただき、お客様のご希望等お伺いいたします。</dd>
                <br className="clear" />
              </dl>
              <dl className="step">
                <dt><img src="/images/lp/step3.png" alt="Step 3" /></dt><dd className="image"><img src="/images/lp/calendar.png" alt="" /></dd><dd className="text">サービス開始日が確定しましたら、メールにて配信させていただきます。</dd>
                <br className="clear" />
              </dl>
              <dl className="step">
                <dt><img src="/images/lp/step4.png" alt="Step 4" /></dt><dd className="image"><img src="/images/lp/clean.png" alt="" /></dd><dd className="text">サービスを開始します。30min.のお掃除をご体験ください。</dd>
                <br className="clear" />
              </dl>
            </div>
          </div>

          <div className="content">
            <div className="label">氏名</div>
            <input type="text" name="family_name" className="input-s" value={this.state.family_name} onChange={e => this.setState({family_name: e.target.value})} placeholder="山田" /><input type="text" name="first_name" className="input-s" value={this.state.first_name} onChange={e => this.setState({first_name: e.target.value})} placeholder="花子" />
            <p className="error-message">{this.state.errors.name}</p>

            <div className="label">フリガナ</div>
            <input type="text" name="family_name_kana" className="input-s" value={this.state.family_name_kana} onChange={e => this.setState({family_name_kana: e.target.value})} placeholder="ヤマダ" /><input type="text" name="first_name_kana" className="input-s" value={this.state.first_name_kana} onChange={e => this.setState({first_name_kana: e.target.value})} placeholder="ハナコ" />
            <p className="error-message">{this.state.errors.name_kana}</p>

            <div className="label">郵便番号</div>
            <input type="text" name="zipcode" value={this.state.zipcode} onChange={e => this.setState({zipcode: e.target.value})} placeholder="123-4567" />
            <p className="error-message">{this.state.errors.zipcode}</p>

            <div className="label">住所</div>
            <input type="text" name="address" value={this.state.address} onChange={e => this.setState({address: e.target.value})} placeholder="東京都千代田区神田猿楽町１丁目２−２" />
            <p className="error-message">{this.state.errors.address}</p>

            <div className="label">マンション名・部屋番号</div>
            <input type="text" name="apartment" value={this.state.apartment} onChange={e => this.setState({apartment: e.target.value})} placeholder="ザ・パークハウスアーバンス千代田御茶ノ水" />
            <p className="error-message">{this.state.errors.apartment}</p>

            <div className="label">電話番号</div>
            <input type="text" name="tel" value={this.state.tel} onChange={e => this.setState({tel: e.target.value})} placeholder="090-1234-5678" />
            <p className="error-message">{this.state.errors.tel}</p>

            <div className="label">メールアドレス</div>
            <input type="text" name="email" value={this.state.email} onChange={e => this.setState({email: e.target.value})} placeholder="yamada@gmail.com" />
            <p className="error-message">{this.state.errors.email}</p>

            <div className="label">年代</div>
            <select name="age" onChange={e => this.setState({age: e.target.value})}>
              {age_list}
            </select>
            <p className="error-message">{this.state.errors.age}</p>

            <div className="label">性別</div>
            <select name="sex" onChange={e => this.setState({sex: e.target.value})}>
              {sex_list}
            </select>
            <p className="error-message">{this.state.errors.sex}</p>

            <div className="label">家族構成</div>
            <select name="family" onChange={e => this.setState({family: e.target.value})}>
              {family_list}
            </select>
            <p className="error-message">{this.state.errors.family}</p>

            <div className="label">掃除頻度</div>
            <select name="cleaning_frequency" onChange={e => this.setState({cleaning_frequency: e.target.value})}>
              {cleaning_frequency_list}
            </select>
            <p className="error-message">{this.state.errors.cleaning_frequency}</p>

            <div className="label">子供</div>
            <select name="children" onChange={e => this.setState({children: e.target.value})}>
              {children_list}
            </select>
            <p className="error-message">{this.state.errors.children}</p>

            <div className="label">ペット</div>
            <select name="pet" onChange={e => this.setState({pet: e.target.value})}>
              {pet_list}
            </select>
            <p className="error-message">{this.state.errors.pet}</p>

            <div className="label">ご希望の時間数</div>
            <select name="lot" onChange={e => this.setState({lot: e.target.value})}>
              {lot_list}
            </select>
            <p className="error-message">{this.state.errors.lot}</p>

            <div className="label">ご希望の掃除内容</div>
            <textarea name="menu" className="schedule-textarea" onChange={e => this.setState({menu: e.target.value})} placeholder="リビング・ダイニング" />
            <p className="error-message">{this.state.errors.menu}</p>

            <div className="label">ご希望の曜日・時間</div>
            <textarea name="schedule" className="schedule-textarea" onChange={e => this.setState({schedule: e.target.value})} placeholder="平日10:00〜16:00の間、土曜午前中" />
            <p className="error-message">{this.state.errors.schedule}</p>

            <label><input name="terms" className="checkbox-margin" type="checkbox" checked={this.state.terms} onChange={e => this.setCheck("terms", e.target.checked)} /><a href="https://f.hubspotusercontent30.net/hubfs/7085787/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E2%80%97%E6%B3%95%E4%BA%BA%E8%BF%BD%E5%8A%A0%E6%9C%80%E7%B5%82%E7%89%88.pdf" target="_blank" rel="noopener noreferrer">利用規約</a>に同意する</label>
            <p className="error-message">{this.state.errors.terms}</p>

            <label><input name="privacy" className="checkbox-margin" type="checkbox" checked={this.state.privacy} onChange={e => this.setCheck("privacy", e.target.checked)} /><a href="https://www.mec.co.jp/j/privacy/" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>に同意する</label>
            <p className="error-message">{this.state.errors.privacy}</p>

            <p className="error-message">{this.state.errors.server}</p>
            <div className="buttons">
              <button id="registration" onClick={this.validation.bind(this)} className={[this.state.on_submit === true ? "on_submit" : ""]} disabled={this.state.on_submit}>お申し込み</button>
            </div>
          </div>
        </div>
        <div className="campaign-footer">
          <div className="footer-title">【ご利用について】</div>
          <p>●本キャンペーンは、チラシが配布されたマンションにお住まいの方限定のキャンペーンとなります。</p>
          <p>●30min.の家事代行サービスは、週1回〜の定期サービスのみとなります。</p>
          <p>●本キャンペーン後、継続してサービスをご利用いただく場合には定価(下記)でのご案内となります。</p>
          <table className="prices">
            <tr><td>30分</td><td>2,500円</td><td>お掃除内容は「リビング・ダイニング」「洗面所・お手洗い」からお選びいただけます</td></tr>
            <tr><td>60分</td><td>4,000円</td><td rowspan="3">お掃除内容は「リビング・ダイニング」「洗面所・お手洗い」「お風呂」「キッチン」からお選びいただけます</td></tr>
            <tr><td>90分</td><td>6,000円</td></tr>
            <tr><td>120分</td><td>8,000円</td></tr>
          </table>
          <br />
          <p>●本サービスは、マンション内をハウスキーパーが巡回することにより、短時間(30分)からのサービス提供を可能とするサービスでございます。</p>
          <p>●既定数に達し次第、お申し込みを締め切らせていただきます。</p>
          <p>●12月24日〜1月6日は、サービスのご提供をお休みさせていただきます。</p>
          <p>●お申し込み時期・ご依頼時の状況により、年内のサービスのご提供ができない場合がございます。あらかじめご了承くださいませ。</p>
          <p>●お申し込み状況により、ご希望の曜日・時間帯にお申し込みいただけない場合がございます。あらかじめご了承くださいませ。</p>
          <br />
          <div className="footer-title">【個人情報の取り扱いについて】</div>
          <p>当社は個人情報等に関する法令及びガイドライン等を遵守して、個人情報等の適正な取り扱いを行います／本フォームで取得した情報は当社の家事代行サービスに係るサービス提供・事業検証・事業化検証の為のアンケートやインタビュー依頼の目的で利用させて頂きます／当社は上記に記載の目的の達成に必要な範囲で当社グループ会社等と個人情報を共同利用することがあります。その場合の個人情報は登録フォームの全ての項目となり、管理責任の所在は、当社となります／ご登録者様から頂いた情報については、守秘義務を締結の上、三菱地所から業務委託を行っている外部の担当者等と共有させて頂く可能性がございます／事業化検証の経過・結果の一部として本フォーム登録結果を外部に開示する可能性がありますが、その場合、個人を特定されない形に集計して利用致します。</p>
          <p>※本件及び本件に係る個人情報の取り扱いについてのお問い合わせ先：三菱地所株式会社・住宅業務企画部　中村・松沢　thirty-min@mec.co.jp</p>
        </div>
      </div>
    </div>
    );
  }
}